import { useLocation } from 'react-router-dom';
import TableLayout from '../../components/TableLayout';
import { useFetchData } from '../../hooks/useFetchData';
import { API_URL } from '../../utils/constant';
import { useState } from 'react';

const headers = [
    {
        key: 'point',
        name: 'Point'
    },
    {
        key: 'mmk_amount',
        name: 'MMK Amount'
    },
    {
        key: 'thb_amount',
        name: 'THB Amount'
    },
    
];

const GiftRuleList = () => {
    const [searchValue, setSearchValue] = useState("");
    const location = useLocation();
    const currentPath = location.pathname;

    const handleSearch = (value) => {
        const trimmed = value.trim();
        if (trimmed.length > 0) {
            setSearchValue(trimmed);
            setQuery({ search: trimmed });
        } else {
            setSearchValue("");
            setQuery({});
        }
    }

    const { data, setCurrentPage, setQuery, reload } = useFetchData({
        url: API_URL + '/pointRule',
        defaultQuery: 'status=ACTIVE'
    });

    const nothingFoundAfterSearch =
        searchValue && Array.isArray(data?.results) && data.results.length === 0;


    return (
        <TableLayout
            title='Point Rule List'
            data={data}
            headers={headers}
            idKey='point_rule_id'
            endPoint='/pointRule'
            setCurrentPage={setCurrentPage}
            removeDetails={true}
            hasSearch
            hasCreate
            hasActions
            createPath={`/loyalty/point-rule/list/create`}
            currentPath={currentPath}
            onSearch={(value) => handleSearch(value)}
            disabledSerial
            reload={reload}
            setQuery={setQuery}
            searchValue={searchValue}
            nothingFoundAfterSearch={nothingFoundAfterSearch}
        />
    )
}
 
export default GiftRuleList;
